module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAALZJREFUWEdjZBhgwDjA9jOMOmA0BEZDYDQEqBYCessfLmDlYc066yv1jZTCjYoOePCfkZHxGhMTQ+j5MPlrxDqCqg4AWcrIyPiN8T9j9oVIuQXEOILqDkBYyriQmCihoQPAoUEwSnA6QG/5g//EBCEhNYSihD4OYGTIuhAuvxCbYwdvFBAKWnR5zCgboEQIjnM8QY7ucKpGATGpnoYOGOCimNQ0A1NPtSgYdcBoCIyGwGgIkBsCAPceSCGY/wwGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/image/newsIcon.png
// module id = Pg6n
// module chunks = 1